export default __webpack_public_path__ + "locales/ja-JP/Notifications.json?hash=f948e6ea26d21d410cbbd8b7c4cc62c0";